import React from 'react';
import Dropdown from 'react-dropdown';

export const LabeledSelect = ({
    label,
    options,
    onChange,
    value,
    className
}) => (
    <div className={className}>
        <span className={'select-label'}>{label}</span>
        <Dropdown
            options={options}
            onChange={option => onChange(option.value)}
            value={value}
        />
    </div>
);
